import { render } from "./Scenario.vue?vue&type=template&id=4cc773da&ts=true&lang=html"
import script from "./Scenario.vue?vue&type=script&lang=ts"
export * from "./Scenario.vue?vue&type=script&lang=ts"

import "./Scenario.vue?vue&type=style&index=0&id=4cc773da&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__